import React, { useState, useRef, useEffect } from "react";

import { withStyles, createStyles, Theme } from "@material-ui/core/styles";

import Select from "@material-ui/core/Select";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
      height: "100%",
      backgroundColor: "transparent",
    },
  });

const CustomDropdownEditorUnstyled = ({ row, column, onRowChange, classes, options, filter, displayKey }) => {
  const ref: any = useRef();
  const [open, setOpen] = useState(true);

  const handleChange = (event) => {
    onRowChange({ ...row, [column.key]: event.target.value }, true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  useEffect(() => {
    if (ref.current) {
      ref.current.focus();
    }
  }, []);

  const handleKeyPress = (event) => {
    // tab key press
    if (event.keyCode === 9 || event.keyCode === 27) {
      event.preventDefault();
      onRowChange({ ...row, [column.key]: row[column.key] ? row[column.key] : (options[0] || { value: null }).value }, true);
      setOpen(false);
    }
  };

  return (
    <Select
      onKeyDown={handleKeyPress}
      native
      ref={ref}
      open={open}
      onOpen={handleOpen}
      onClose={handleClose}
      value={row[column.key]}
      onChange={handleChange}
      className={classes.root}
    >
      <option aria-label="None" value="" />
      {options
        .filter((item) => (filter ? item.data[filter.field] == filter.value : item))
        .map((item, indx) => (
          <option key={indx} value={item.value}>
            {displayKey ? item[displayKey] : item.value}
          </option>
        ))}
    </Select>
  );
};

export default withStyles(styles)(CustomDropdownEditorUnstyled);
